import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BottomTabNavigation from '../../components/ui/BottomTabNavigation';
import CategoryFilter from '../../components/ui/CategoryFilter';
import VendorDetailModal from '../../components/ui/VendorDetailModal';
import FilterHeader from './components/FilterHeader';
import EmptyState from './components/EmptyState';
import VendorGrid from './components/VendorGrid';

const ServiceListingScreen = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [filteredVendors, setFilteredVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const servicesData = [
        {
            id: 1,
            name: "Capture Moments Studio",
            category: "Photography",
            rating: 4.8,
            reviewsCount: 127,
            price: 15000,
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a71464aa-1769423778379.png",
            imageAlt: "Professional photographer with camera equipment capturing wedding moments in elegant venue with soft lighting",
            description: "Award-winning wedding photography with cinematic storytelling approach. Specializing in candid moments and traditional portraits with 10+ years experience.",
            location: "Downtown Studio, Main Street",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543210",
            email: "info@capturemoments.com",
            services: ["Pre-wedding Shoot", "Wedding Day Coverage", "Candid Photography", "Traditional Portraits", "Album Design"],
            reviews: [
                {
                    author: "Priya Sharma",
                    rating: 5,
                    comment: "Absolutely stunning work! They captured every emotion perfectly. The candid shots were breathtaking.",
                    date: "January 15, 2026"
                },
                {
                    author: "Rahul Verma",
                    rating: 4.5,
                    comment: "Professional team with great attention to detail. Highly recommended for wedding photography.",
                    date: "December 28, 2025"
                }]

        },
        {
            id: 2,
            name: "Royal Tent House",
            category: "Tent House",
            rating: 4.6,
            reviewsCount: 89,
            price: 50000,
            image: "https://images.unsplash.com/photo-1649750396712-e34431b1f4aa",
            imageAlt: "Luxurious white wedding tent with elegant draping, crystal chandeliers, and floral decorations for outdoor celebration",
            description: "Premium tent and decoration services for weddings and events. Offering customized setups with elegant designs and complete event management.",
            location: "Event Plaza, Ring Road",
            city: "Delhi",
            state: "Delhi",
            phone: "+919876543211",
            email: "bookings@royaltenthouse.com",
            services: ["Tent Setup", "Stage Decoration", "Lighting Arrangement", "Seating Management", "Complete Event Setup"],
            reviews: [
                {
                    author: "Amit Patel",
                    rating: 5,
                    comment: "Transformed our venue into a magical space. The tent setup was flawless and the decoration was beyond expectations.",
                    date: "January 20, 2026"
                },
                {
                    author: "Neha Singh",
                    rating: 4,
                    comment: "Good service and professional team. Setup was completed on time with beautiful results.",
                    date: "January 5, 2026"
                }]

        },
        {
            id: 3,
            name: "Spice Garden Caterers",
            category: "Catering",
            rating: 4.9,
            reviewsCount: 156,
            price: 800,
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b53b4465-1766555467088.png",
            imageAlt: "Elegant buffet spread with variety of Indian cuisine dishes, colorful presentations, and professional catering setup",
            description: "Multi-cuisine catering specialists with focus on authentic flavors and presentation. Serving 100-5000 guests with customized menus and live counters.",
            location: "Catering Complex, Food Street",
            city: "Bangalore",
            state: "Karnataka",
            phone: "+919876543212",
            email: "orders@spicegarden.com",
            services: ["Multi-cuisine Menu", "Live Counters", "Dessert Station", "Beverage Service", "Staff & Service"],
            reviews: [
                {
                    author: "Kavita Reddy",
                    rating: 5,
                    comment: "Outstanding food quality and presentation. Guests couldn\'t stop praising the taste. Highly professional service.",
                    date: "January 25, 2026"
                },
                {
                    author: "Suresh Kumar",
                    rating: 5,
                    comment: "Best catering service we\'ve experienced. The live counters were a huge hit at our wedding.",
                    date: "January 10, 2026"
                }]

        },
        {
            id: 4,
            name: "Beat Masters DJ",
            category: "DJ",
            rating: 4.7,
            reviewsCount: 94,
            price: 25000,
            image: "https://images.unsplash.com/photo-1564316977905-221efcd0a1f3",
            imageAlt: "Professional DJ performing at wedding with colorful stage lighting, sound equipment, and energetic crowd dancing",
            description: "Professional DJ services with state-of-the-art sound and lighting equipment. Specializing in Bollywood, EDM, and retro music with customized playlists.",
            location: "Entertainment Hub, Party District",
            city: "Pune",
            state: "Maharashtra",
            phone: "+919876543213",
            email: "bookings@beatmastersdj.com",
            services: ["DJ Performance", "Sound System", "Stage Lighting", "LED Screens", "Fog & Effects"],
            reviews: [
                {
                    author: "Rohan Desai",
                    rating: 5,
                    comment: "Amazing energy throughout the event! The music selection was perfect and kept everyone dancing all night.",
                    date: "January 18, 2026"
                },
                {
                    author: "Anjali Mehta",
                    rating: 4.5,
                    comment: "Great DJ with excellent equipment. The lighting effects added so much to the ambiance.",
                    date: "December 30, 2025"
                }]

        },
        {
            id: 5,
            name: "Glamour Touch Makeup",
            category: "Makeup Artist",
            rating: 4.9,
            reviewsCount: 142,
            price: 12000,
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_136a32d4d-1770142316664.png",
            imageAlt: "Professional makeup artist applying bridal makeup with elegant brushes and cosmetics in well-lit studio setting",
            description: "Celebrity makeup artist specializing in bridal and party makeup. Using premium international brands with personalized consultations and trial sessions.",
            location: "Beauty Studio, Fashion Avenue",
            city: "Mumbai",
            state: "Maharashtra",
            phone: "+919876543214",
            email: "bookings@glamourtouch.com",
            services: ["Bridal Makeup", "Party Makeup", "Hair Styling", "Saree Draping", "Pre-wedding Trials"],
            reviews: [
                {
                    author: "Divya Iyer",
                    rating: 5,
                    comment: "Made me look absolutely stunning on my wedding day! The makeup lasted all day and looked flawless in photos.",
                    date: "January 22, 2026"
                },
                {
                    author: "Shreya Nair",
                    rating: 5,
                    comment: "Incredible talent and very professional. The trial session helped us finalize the perfect look.",
                    date: "January 8, 2026"
                }]

        },
        {
            id: 6,
            name: "Lens & Light Photography",
            category: "Photography",
            rating: 4.7,
            reviewsCount: 103,
            price: 18000,
            image: "https://images.unsplash.com/flagged/photo-1567793483424-e20eb6c94a53",
            imageAlt: "Wedding photographer capturing couple's romantic moment outdoors with professional camera and natural lighting setup",
            description: "Contemporary wedding photography with artistic vision. Offering drone coverage, same-day edits, and cinematic wedding films with quick delivery.",
            location: "Creative Studio, Arts District",
            city: "Hyderabad",
            state: "Telangana",
            phone: "+919876543215",
            email: "hello@lensandlight.com",
            services: ["Drone Photography", "Cinematic Films", "Same-day Edits", "Photo Albums", "Digital Delivery"],
            reviews: [
                {
                    author: "Karthik Rao",
                    rating: 5,
                    comment: "The drone shots were spectacular! They captured angles we never imagined. Truly creative work.",
                    date: "January 12, 2026"
                },
                {
                    author: "Meera Krishnan",
                    rating: 4.5,
                    comment: "Beautiful photography with quick turnaround. The same-day edit was a wonderful surprise for our guests.",
                    date: "December 20, 2025"
                }]

        },
        {
            id: 7,
            name: "Grand Pavilion Tents",
            category: "Tent House",
            rating: 4.5,
            reviewsCount: 76,
            price: 60000,
            image: "https://images.unsplash.com/photo-1649750396712-e34431b1f4aa",
            imageAlt: "Large outdoor wedding tent with transparent ceiling, elegant white draping, and sophisticated lighting for evening event",
            description: "Luxury tent solutions for grand celebrations. Specializing in transparent tents, German hangars, and complete outdoor event infrastructure with climate control.",
            location: "Event Grounds, Highway Plaza",
            city: "Jaipur",
            state: "Rajasthan",
            phone: "+919876543216",
            email: "info@grandpavilion.com",
            services: ["Transparent Tents", "German Hangars", "Climate Control", "Flooring", "Complete Infrastructure"],
            reviews: [
                {
                    author: "Vikram Singh",
                    rating: 5,
                    comment: "The transparent tent was absolutely stunning! Guests could enjoy the starry night while staying comfortable inside.",
                    date: "January 16, 2026"
                },
                {
                    author: "Pooja Rathore",
                    rating: 4,
                    comment: "Professional setup with attention to every detail. The climate control made a huge difference.",
                    date: "January 2, 2026"
                }]

        },
        {
            id: 8,
            name: "Flavors of India Catering",
            category: "Catering",
            rating: 4.8,
            reviewsCount: 134,
            price: 750,
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e1a56776-1765253443748.png",
            imageAlt: "Colorful Indian wedding feast with variety of traditional dishes, decorative serving platters, and professional presentation",
            description: "Traditional and fusion catering with regional specialties. Expert in North Indian, South Indian, and Continental cuisines with customizable menus for all dietary preferences.",
            location: "Culinary Center, Food Park",
            city: "Chennai",
            state: "Tamil Nadu",
            phone: "+919876543217",
            email: "bookings@flavorsofindia.com",
            services: ["Regional Cuisines", "Fusion Menu", "Jain Food", "Vegan Options", "Live Cooking Stations"],
            reviews: [
                {
                    author: "Lakshmi Venkat",
                    rating: 5,
                    comment: "Authentic South Indian flavors that reminded us of home. The dosa counter was a massive hit!",
                    date: "January 24, 2026"
                },
                {
                    author: "Arjun Pillai",
                    rating: 4.5,
                    comment: "Excellent variety and taste. They accommodated all our dietary requirements perfectly.",
                    date: "January 7, 2026"
                }]

        },
        {
            id: 9,
            name: "Rhythm Nation DJ",
            category: "DJ",
            rating: 4.6,
            reviewsCount: 81,
            price: 22000,
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_147c596c8-1766130277188.png",
            imageAlt: "DJ mixing music at outdoor wedding reception with professional turntables, colorful lights, and dancing guests",
            description: "High-energy DJ performances with interactive crowd engagement. Specializing in destination weddings with portable premium equipment and backup systems.",
            location: "Music Studio, Entertainment Zone",
            city: "Goa",
            state: "Goa",
            phone: "+919876543218",
            email: "bookings@rhythmnation.com",
            services: ["DJ Sets", "Portable Equipment", "Backup Systems", "Crowd Interaction", "Custom Playlists"],
            reviews: [
                {
                    author: "Siddharth Malhotra",
                    rating: 5,
                    comment: "Perfect for our beach wedding! The music kept everyone energized from start to finish.",
                    date: "January 14, 2026"
                },
                {
                    author: "Tanya Kapoor",
                    rating: 4.5,
                    comment: "Great DJ with excellent music sense. The portable setup worked flawlessly at our outdoor venue.",
                    date: "December 25, 2025"
                }]

        },
        {
            id: 10,
            name: "Radiance Bridal Studio",
            category: "Makeup Artist",
            rating: 4.8,
            reviewsCount: 118,
            price: 15000,
            image: "https://images.unsplash.com/photo-1653127636818-cf9c98233ff5",
            imageAlt: "Bride getting professional makeup application with luxury cosmetics in elegant bridal studio with mirror lights",
            description: "Luxury bridal makeup and styling services with personalized packages. Offering HD makeup, airbrush techniques, and complete bridal grooming with on-location services.",
            location: "Bridal Suite, Wedding Plaza",
            city: "Kolkata",
            state: "West Bengal",
            phone: "+919876543219",
            email: "bookings@radiancebridal.com",
            services: ["HD Makeup", "Airbrush Makeup", "Hair Styling", "Nail Art", "On-location Service"],
            reviews: [
                {
                    author: "Riya Chatterjee",
                    rating: 5,
                    comment: "The HD makeup looked absolutely natural yet glamorous. Stayed perfect throughout the 12-hour event!",
                    date: "January 19, 2026"
                },
                {
                    author: "Ananya Das",
                    rating: 4.5,
                    comment: "Professional and talented team. The airbrush technique gave a flawless finish in all photos.",
                    date: "January 3, 2026"
                }]

        },
        {
            id: 11,
            name: "Eternal Frames Photography",
            category: "Photography",
            rating: 4.9,
            reviewsCount: 145,
            price: 20000,
            image: "https://images.unsplash.com/photo-1706565027774-165d723eafa5",
            imageAlt: "Professional wedding photographer capturing intimate couple moment with high-end camera equipment in romantic setting",
            description: "Premium wedding photography with international style. Specializing in destination weddings, pre-wedding shoots, and luxury wedding albums with worldwide coverage.",
            location: "Photography Studio, Creative Hub",
            city: "Udaipur",
            state: "Rajasthan",
            phone: "+919876543220",
            email: "bookings@eternalframes.com",
            services: ["Destination Coverage", "Pre-wedding Shoots", "Luxury Albums", "International Style", "Video Production"],
            reviews: [
                {
                    author: "Aditya Sharma",
                    rating: 5,
                    comment: "They traveled to our destination wedding and captured every moment beautifully. Worth every penny!",
                    date: "January 21, 2026"
                },
                {
                    author: "Ishita Gupta",
                    rating: 5,
                    comment: "The pre-wedding shoot was like a dream! Their creative vision and execution are unmatched.",
                    date: "December 28, 2025"
                }]

        },
        {
            id: 12,
            name: "Elite Event Tents",
            category: "Tent House",
            rating: 4.7,
            reviewsCount: 92,
            price: 55000,
            image: "https://images.unsplash.com/photo-1707097702231-f0b98d7c2703",
            imageAlt: "Elegant wedding tent interior with draped fabric ceiling, crystal chandeliers, and sophisticated table arrangements",
            description: "Premium tent rental and event setup services. Offering customized tent solutions with complete decoration, furniture, and lighting for memorable celebrations.",
            location: "Event Complex, Exhibition Road",
            city: "Ahmedabad",
            state: "Gujarat",
            phone: "+919876543221",
            email: "info@eliteeventtents.com",
            services: ["Custom Tents", "Furniture Rental", "Lighting Design", "Decoration", "Complete Setup"],
            reviews: [
                {
                    author: "Harsh Patel",
                    rating: 5,
                    comment: "The tent setup was magnificent! They handled everything from start to finish professionally.",
                    date: "January 17, 2026"
                },
                {
                    author: "Nisha Shah",
                    rating: 4.5,
                    comment: "Beautiful decoration and excellent service. The lighting design created a magical atmosphere.",
                    date: "January 1, 2026"
                }]

        },
        {
            id: 13,
            name: "Royal Feast Caterers",
            category: "Catering",
            rating: 4.7,
            reviewsCount: 128,
            price: 850,
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e1a56776-1765253443748.png",
            imageAlt: "Luxurious wedding buffet with international cuisine, elegant serving stations, and professional catering presentation",
            description: "Gourmet catering services with international and Indian fusion menus. Specializing in themed food stations, molecular gastronomy, and personalized dining experiences.",
            location: "Catering Kitchen, Food District",
            city: "Lucknow",
            state: "Uttar Pradesh",
            phone: "+919876543222",
            email: "orders@royalfeast.com",
            services: ["Fusion Cuisine", "Themed Stations", "Molecular Gastronomy", "Personalized Menus", "Premium Service"],
            reviews: [
                {
                    author: "Abhishek Verma",
                    rating: 5,
                    comment: "The fusion menu was extraordinary! Guests are still talking about the innovative food presentations.",
                    date: "January 23, 2026"
                },
                {
                    author: "Priyanka Mishra",
                    rating: 4.5,
                    comment: "Exceptional quality and presentation. The themed food stations were a unique touch.",
                    date: "January 6, 2026"
                }]

        },
        {
            id: 14,
            name: "Sonic Waves DJ",
            category: "DJ",
            rating: 4.8,
            reviewsCount: 107,
            price: 28000,
            image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2ba3368-1769550831738.png",
            imageAlt: "Professional DJ performing at indoor wedding with advanced mixing equipment, LED panels, and energetic dance floor",
            description: "Premium DJ entertainment with cutting-edge technology. Offering 3D mapping, LED walls, and synchronized lighting shows for unforgettable wedding celebrations.",
            location: "Sound Studio, Music Avenue",
            city: "Chandigarh",
            state: "Punjab",
            phone: "+919876543223",
            email: "bookings@sonicwaves.com",
            services: ["3D Mapping", "LED Walls", "Synchronized Lighting", "Premium Sound", "Visual Effects"],
            reviews: [
                {
                    author: "Manpreet Singh",
                    rating: 5,
                    comment: "The 3D mapping and LED walls took our wedding to another level! Absolutely mind-blowing experience.",
                    date: "January 13, 2026"
                },
                {
                    author: "Simran Kaur",
                    rating: 4.5,
                    comment: "Top-notch equipment and professional service. The visual effects were stunning!",
                    date: "December 22, 2025"
                }]

        },
        {
            id: 15,
            name: "Elegance Makeup Artistry",
            category: "Makeup Artist",
            rating: 4.9,
            reviewsCount: 151,
            price: 18000,
            image: "https://images.unsplash.com/photo-1638628064365-f08ad0ec8245",
            imageAlt: "Professional makeup artist working on bride\'s face with premium cosmetics in luxury bridal preparation room",
            description: "Celebrity makeup artist with expertise in traditional and contemporary bridal looks. Using organic products with customized skincare routines and complete bridal packages.",
            location: "Beauty Lounge, Fashion Street",
            city: "Delhi",
            state: "Delhi",
            phone: "+919876543224",
            email: "bookings@elegancemakeup.com",
            services: ["Organic Makeup", "Skincare Routine", "Traditional Looks", "Contemporary Styles", "Complete Packages"],
            reviews: [
                {
                    author: "Sanya Malhotra",
                    rating: 5,
                    comment: "The organic products were gentle on my sensitive skin and the makeup looked flawless all day!",
                    date: "January 26, 2026"
                },
                {
                    author: "Kiara Advani",
                    rating: 5,
                    comment: "Incredible talent! The traditional bridal look was exactly what I dreamed of. Highly recommended!",
                    date: "January 9, 2026"
                }]

        }];


    const categoryMap = {
        'all': 'All Services',
        'photography': 'Photography',
        'catering': 'Catering',
        'decoration': 'Tent House',
        'music': 'DJ',
        'venue': 'Venues',
        'makeup': 'Makeup Artist'
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const category = params?.get('category') || 'all';
        setSelectedCategory(category);
    }, [location?.search]);

    useEffect(() => {
        if (selectedCategory === 'all') {
            setFilteredVendors(servicesData);
        } else {
            const categoryName = categoryMap?.[selectedCategory];
            const filtered = servicesData?.filter(
                (vendor) => vendor?.category?.toLowerCase() === categoryName?.toLowerCase()
            );
            setFilteredVendors(filtered);
        }
    }, [selectedCategory]);

    const handleCategoryChange = (categoryId) => {
        setSelectedCategory(categoryId);
        navigate(`/service-listing-screen?category=${categoryId}`);
    };

    const handleVendorClick = (vendor) => {
        setSelectedVendor(vendor);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setTimeout(() => setSelectedVendor(null), 300);
    };

    const handleResetFilter = () => {
        setSelectedCategory('all');
        navigate('/service-listing-screen?category=all');
    };

    const getCategoryDisplayName = () => {
        return categoryMap?.[selectedCategory] || 'All Services';
    };

    return (
        <div className="min-h-screen bg-background pb-20">
            <FilterHeader
                categoryName={getCategoryDisplayName()}
                totalResults={filteredVendors?.length} />

            <div className="py-4 md:py-6">
                <CategoryFilter onCategoryChange={handleCategoryChange} />
            </div>
            <main className="content-container section-spacing">
                {filteredVendors?.length > 0 ?
                    <VendorGrid
                        vendors={filteredVendors}
                        onVendorClick={handleVendorClick} /> :


                    <EmptyState onResetFilter={handleResetFilter} />
                }
            </main>
            <BottomTabNavigation />
            <VendorDetailModal
                vendor={selectedVendor}
                isOpen={isModalOpen}
                onClose={handleCloseModal} />

        </div>);

};

export default ServiceListingScreen;